module.exports = __webpack_public_path__ + "img/default-cover.220be985.svg";